export default {
  normal: {
    defaultPageSize: 20,
    pageSizes: [20, 50, 100],
    layouts: ['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']
  },
  product: {
    defaultPageSize: 30,
    pageSizes: [30, 60, 90],
    layouts: ['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']
  }
}